(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai-prompt"] && !Shopify.designMode) return;
  try {
    class AiPrompt extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('[data-text]');
      this.chatgpt = this.querySelector('[data-chatgpt]');
      this.status = this.querySelector('[data-status]');
      this.statusText = this.querySelector('[data-status-text]');
      this.statusLink = this.querySelector('[data-status-link]');
      if (!this.text) return;

      this.syncLink();
      this.text.addEventListener('input', () => {
        this.syncLink();
        this.status.hidden = true;
      });
      this.querySelectorAll('[data-copy]').forEach((button) => {
        button.addEventListener('click', () => this.copy(button));
      });
    }

    syncLink() {
      if (this.chatgpt) this.chatgpt.href = 'https://chatgpt.com/?q=' + encodeURIComponent(this.text.value.trim());
    }

    async copy(button) {
      const value = this.text.value.trim();
      let copied = false;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          /* Chrome leaves the write pending, rather than refusing it, in a tab it treats as hidden. */
          const timeout = new Promise((resolve, reject) => setTimeout(() => reject(new Error('timeout')), 1500));
          await Promise.race([navigator.clipboard.writeText(value), timeout]);
          copied = true;
        }
      } catch (error) {
        copied = false;
      }
      if (!copied) {
        this.text.focus();
        this.text.select();
        try {
          copied = document.execCommand('copy');
        } catch (error) {
          copied = false;
        }
      }
      this.statusText.textContent = (copied ? this.dataset.tCopied : this.dataset.tBlocked) + ' ';
      this.statusLink.href = button.dataset.url;
      this.statusLink.textContent = button.dataset.openLabel;
      this.status.hidden = false;
    }
  }

  if (!customElements.get('ai-prompt')) customElements.define('ai-prompt', AiPrompt);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["device-guide"] && !Shopify.designMode) return;
  try {
    class DeviceGuide extends HTMLElement {
    connectedCallback() {
      this.panels = Array.prototype.filter.call(
        this.querySelectorAll('[data-device-panel]'),
        (panel) => panel.closest('device-guide') === this
      );
      if (this.panels.length < 2) return;

      const list = this.querySelector('[data-device-tabs]');
      list.setAttribute('aria-label', this.dataset.tabsLabel || '');
      list.replaceChildren();

      this.tabs = this.panels.map((panel, index) => {
        const id = 'device-' + Math.random().toString(36).slice(2, 9);
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'device-guide__tab';
        tab.id = id + '-tab';
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', id);
        tab.textContent = panel.dataset.label || String(index + 1);
        tab.addEventListener('click', () => this.select(index, false));
        tab.addEventListener('keydown', (event) => this.onKey(event, index));

        panel.id = id;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = -1;

        list.append(tab);
        return tab;
      });

      list.hidden = false;
      this.classList.add('device-guide--tabs');

      const platform = this.platform();
      const match = this.panels.findIndex((panel) => panel.dataset.platform === platform);
      this.select(match === -1 ? 0 : match, false);

      /* A looping clip that will not stop is a problem for anyone who asked
         for less motion, so it gets controls and starts paused. */
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.querySelectorAll('video').forEach((video) => {
          video.pause();
          video.removeAttribute('autoplay');
          video.controls = true;
        });
      } else {
        this.querySelectorAll('video').forEach((video) => this.keepPlaying(video));
      }

      this.onEditorSelect = (event) => {
        const index = this.panels.findIndex((panel) => panel.contains(event.target));
        if (index !== -1) this.select(index, false);
      };
      document.addEventListener('shopify:block:select', this.onEditorSelect);
    }

    disconnectedCallback() {
      if (this.onEditorSelect) document.removeEventListener('shopify:block:select', this.onEditorSelect);
    }

    /*
     * An iPhone in Low Power Mode refuses to autoplay any video, even a muted
     * one, and shows its play button instead. A tap is what lets it play, and
     * iOS counts the end of a touch, not its start, so the clip retries on
     * every tap, click or key until it is playing. A scroll is not a tap and
     * does not count.
     */
    keepPlaying(video) {
      const attempt = video.play();
      if (!attempt || !attempt.catch) return;
      attempt.catch(() => {
        const events = ['touchend', 'click', 'keydown'];
        const start = () => {
          const retry = video.play();
          if (retry && retry.catch) retry.catch(() => {});
        };
        events.forEach((name) => document.addEventListener(name, start, { passive: true }));
        video.addEventListener(
          'playing',
          () => events.forEach((name) => document.removeEventListener(name, start)),
          { once: true }
        );
      });
    }

    /* iPadOS reports itself as a Mac, so a Mac with a touch screen counts. */
    platform() {
      const agent = navigator.userAgent || '';
      if (/iPhone|iPad|iPod/.test(agent)) return 'ios';
      if (/Macintosh/.test(agent) && navigator.maxTouchPoints > 1) return 'ios';
      if (/Android/i.test(agent)) return 'android';
      return '';
    }

    select(index, focus) {
      this.tabs.forEach((tab, position) => {
        const active = position === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        this.panels[position].hidden = !active;
      });
      if (focus) this.tabs[index].focus();
    }

    onKey(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = last;
      if (next === null) return;
      event.preventDefault();
      this.select(next, true);
    }
  }

  if (!customElements.get('device-guide')) {
    customElements.define('device-guide', DeviceGuide);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    class EmailSignup extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('[data-done]') && new URLSearchParams(location.search).has('customer_posted')) {
        this.scrollIntoView({ block: 'center' });
      }
    }
  }

  if (!customElements.get('email-signup')) customElements.define('email-signup', EmailSignup);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["order-panel"] && !Shopify.designMode) return;
  try {
    (function () {
    var STEPS = ['size', 'finish', 'quantity'];

    var DEFAULTS = {
      currency: '$',
      perSheetSuffix: '/ea',
      sheetsOne: 'sheet',
      sheetsOther: 'sheets',
      pendingTotal: '…',
      pendingNote: ''
    };

    /*
     * A link can open the panel on a configuration: the cart's Edit link and
     * the upload page's Change link both carry width, height, quantity and
     * finish. Edit also carries the cart line's key, which rides on to the
     * upload page so the edit replaces that line. Anything malformed is
     * ignored and the panel opens on its defaults.
     */
    var PARAMS = new URLSearchParams(window.location.search);
    var EDIT = PARAMS.get('edit') || '';
    var START = (function () {
      var start = {
        widthIn: Number(PARAMS.get('width')),
        heightIn: Number(PARAMS.get('height')),
        quantity: Number(PARAMS.get('quantity')),
        finish: String(PARAMS.get('finish') || '').toLowerCase()
      };
      var sane = [start.widthIn, start.heightIn, start.quantity].every(function (value) {
        return isFinite(value) && value > 0;
      });
      return sane && start.finish ? start : null;
    })();

    function config(panel) {
      var source = panel.querySelector('[data-ss-price-split]');
      var read = function (name, fallback) {
        if (!source) return fallback;
        var value = source.getAttribute(name);
        return value === null || value === '' ? fallback : value;
      };

      return {
        currency: read('data-ss-currency', DEFAULTS.currency),
        perSheetSuffix: read('data-ss-per-sheet-suffix', DEFAULTS.perSheetSuffix),
        sheetsOne: read('data-ss-sheets-one', DEFAULTS.sheetsOne),
        sheetsOther: read('data-ss-sheets-other', DEFAULTS.sheetsOther),
        pendingTotal: read('data-ss-pending-total', DEFAULTS.pendingTotal),
        pendingNote: read('data-ss-pending-note', DEFAULTS.pendingNote)
      };
    }

    /*
     * The service quotes whole dollars; everything here works in cents so the
     * each-price division rounds the same way the breakdown does.
     */
    function money(symbol, cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return symbol + parts[0] + '.' + parts[1];
    }

    function selectedInput(panel, step) {
      return panel.querySelector('input[data-ss-step="' + step + '"]:checked');
    }

    /*
     * The Custom pill names no option value. Choosing it opens that step's
     * free field, and the step is then read from the field rather than a
     * pill. Size and Quantity each have their own, and they are independent:
     * a 5" x 7" at 1000 sheets is off the tier list but a stock size; an odd
     * size at 100 is a stock quantity.
     */
    function customPicked(panel, step) {
      return !!panel.querySelector(
        'input[data-ss-step="' + step + '"][data-ss-custom]:checked'
      );
    }

    function isCustom(panel) {
      return customPicked(panel, 'size') || customPicked(panel, 'quantity');
    }

    function parseSize(value) {
      var match = String(value || '').match(/([\d.]+)\s*"?\s*[x×]\s*"?\s*([\d.]+)/);
      return match ? { widthIn: Number(match[1]), heightIn: Number(match[2]) } : null;
    }

    function customInput(panel, key) {
      return panel.querySelector('[data-ss-custom-input="' + key + '"]');
    }

    function numberFrom(input) {
      if (!input || input.value === '') return null;
      var value = Number(input.value);
      return isFinite(value) && value > 0 ? value : null;
    }

    /*
     * What is actually being configured: a custom axis reads its field, a
     * stock axis reads the option value it selected. Any part missing makes
     * the whole thing null: there is nothing to price yet.
     */
    function configuration(panel) {
      var finish = selectedInput(panel, 'finish');
      var size;
      var quantity;

      if (customPicked(panel, 'size')) {
        size = {
          widthIn: numberFrom(customInput(panel, 'width')),
          heightIn: numberFrom(customInput(panel, 'height'))
        };
      } else {
        var sizeInput = selectedInput(panel, 'size');
        size = parseSize(sizeInput && sizeInput.getAttribute('data-ss-value'));
      }

      if (customPicked(panel, 'quantity')) {
        quantity = numberFrom(customInput(panel, 'quantity'));
      } else {
        var qtyInput = selectedInput(panel, 'quantity');
        quantity = qtyInput ? parseInt(qtyInput.getAttribute('data-ss-count'), 10) : null;
      }

      if (!size || !size.widthIn || !size.heightIn || !quantity || !finish) return null;

      return {
        widthIn: size.widthIn,
        heightIn: size.heightIn,
        quantity: quantity,
        finish: finish.getAttribute('data-ss-value')
      };
    }

    var SLIDER_POSITIONS = 1000;

    function quantitySlider(panel) {
      return panel.querySelector('[data-ss-custom-slider="quantity"]');
    }

    function quantityBounds(panel) {
      var field = customInput(panel, 'quantity');
      var min = field ? Number(field.getAttribute('min')) : 0;
      var max = field ? Number(field.getAttribute('max')) : 0;
      return { min: min > 0 ? min : 1, max: max > 0 ? max : 1 };
    }

    /*
     * Counts land on readable numbers rather than whatever the curve produces,
     * with the increment growing alongside the count: nobody choosing 3,000
     * sheets cares about the difference 3,025 would make, and at 40 they do.
     * Typing still reaches any exact number; this only shapes the drag.
     */
    function snapQuantity(raw, bounds) {
      var step = raw < 100 ? 5 : raw < 500 ? 10 : raw < 1000 ? 25 : 50;
      var snapped = Math.round(raw / step) * step;
      return Math.max(bounds.min, Math.min(bounds.max, snapped));
    }

    /*
     * Geometric, not linear. On a linear 10-to-5000 track every count below 200
     * shares the first four percent of the travel, which is most real orders in
     * a few pixels. Equal drags now move by roughly equal proportion instead.
     */
    function quantityFromPosition(position, bounds) {
      var ratio = position / SLIDER_POSITIONS;
      return snapQuantity(bounds.min * Math.pow(bounds.max / bounds.min, ratio), bounds);
    }

    function positionFromQuantity(quantity, bounds) {
      if (!(quantity > 0)) return 0;
      var ratio = Math.log(quantity / bounds.min) / Math.log(bounds.max / bounds.min);
      return Math.round(Math.max(0, Math.min(1, ratio)) * SLIDER_POSITIONS);
    }

    /* The field is the value; the slider is a view of it and follows. */
    function syncQuantitySlider(panel) {
      var field = customInput(panel, 'quantity');
      var slider = quantitySlider(panel);
      if (!field || !slider) return;

      var bounds = quantityBounds(panel);
      slider.value = String(positionFromQuantity(Number(field.value), bounds));
      slider.setAttribute('aria-valuetext', field.value);
    }

    /*
     * Custom opens on the value it replaces, read from the pill that was
     * selected a moment ago, recorded on every pass, because choosing Custom
     * is what clears the selection that held it.
     */
    function prefillCustom(panel, step) {
      var last = panel.__ssLastPreset || {};

      if (step === 'size') {
        var size = parseSize(last.size);
        if (!size) return;
        var width = customInput(panel, 'width');
        var height = customInput(panel, 'height');
        if (width) width.value = String(size.widthIn);
        if (height) height.value = String(size.heightIn);
        return;
      }

      var field = customInput(panel, 'quantity');
      if (field && last.quantity) field.value = String(last.quantity);
    }

    function customError(panel, message) {
      var target = panel.querySelector('[data-ss-custom-error]');
      if (!target) return;
      target.textContent = message || '';
      target.hidden = !message;
    }

    function proxy(panel, path, payload) {
      var base = (panel.getAttribute('data-ss-proxy-path') || '').replace(/\/$/, '');

      return fetch(base + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (body) {
            return { ok: response.ok, body: body };
          });
        })
        .catch(function () {
          return { ok: false, body: { error: panel.getAttribute('data-ss-unreachable') || '' } };
        });
    }

    /*
     * The service is authoritative and re-snaps dimensions, so its answer is
     * echoed back into the fields, but never into one the customer is still
     * editing, or a half-typed "1" on the way to "12" is rewritten mid-keystroke.
     */
    function echoSnapped(input, value) {
      if (!input || document.activeElement === input) return;
      input.value = String(value);
    }

    function tierInputs(panel) {
      return Array.prototype.filter.call(
        panel.querySelectorAll('[data-ss-qty-option] input[data-ss-step="quantity"]'),
        function (input) {
          return parseInt(input.getAttribute('data-ss-count'), 10) > 0;
        }
      );
    }

    function writeTierPrice(input, text) {
      var option = input.closest('[data-ss-qty-option]');
      var output = option && option.querySelector('[data-ss-qty-price]');
      if (output) output.textContent = text;
    }

    function eachPrice(settings, totalUsd, count) {
      return money(settings.currency, Math.round(totalUsd * 100) / count) + settings.perSheetSuffix;
    }

    function applyQuote(panel, quote, tiers) {
      var settings = config(panel);
      var cents = Math.round(quote.totalUsd * 100);
      var count = quote.quantity;

      if (customPicked(panel, 'size')) {
        echoSnapped(customInput(panel, 'width'), quote.widthIn);
        echoSnapped(customInput(panel, 'height'), quote.heightIn);
      }

      /* The service clamps as well as snaps, so a count it corrected has to
         show, and the slider has to follow it, not the value that was sent. */
      if (customPicked(panel, 'quantity')) {
        echoSnapped(customInput(panel, 'quantity'), quote.quantity);
        syncQuantitySlider(panel);
      }

      /*
       * Each quantity pill prices itself against the current size and finish,
       * so the tier list reads as a live comparison. The
       * ladder comes back in the order it was asked for, null where a rung
       * could not be priced.
       */
      var ladder = quote.ladder || [];
      tiers.forEach(function (input, index) {
        var rung = ladder[index];
        writeTierPrice(input, rung ? eachPrice(settings, rung.totalUsd, rung.quantity) : '');
      });

      var noun = count === 1 ? settings.sheetsOne : settings.sheetsOther;

      writeReadings(
        panel,
        money(settings.currency, cents),
        eachPrice(settings, quote.totalUsd, count) + ' · ' + count + ' ' + noun
      );
    }

    /*
     * One round trip per settled change: the selection and every tier rung
     * in the same request. The request id is bumped before the fetch goes
     * out, so an answer already in flight is stale the moment the customer
     * touches anything: bumping at reply time left a window where an older
     * reply echoed its own count back over the slider mid-drag.
     */
    function refreshQuote(panel, request) {
      if (request === undefined) {
        panel.__ssQuoteId = (panel.__ssQuoteId || 0) + 1;
        request = panel.__ssQuoteId;
      }

      var selected = configuration(panel);

      if (!selected) {
        panel.__ssQuote = null;
        customError(panel, '');
        pendingReadings(panel);
        setContinue(panel, null);
        return;
      }

      var tiers = tierInputs(panel);
      var payload = {
        widthIn: selected.widthIn,
        heightIn: selected.heightIn,
        quantity: selected.quantity,
        finish: selected.finish,
        ladder: tiers.map(function (input) {
          return parseInt(input.getAttribute('data-ss-count'), 10);
        })
      };

      proxy(panel, '/sheet-quote', payload).then(function (result) {
        if (request !== panel.__ssQuoteId) return;

        if (!result.ok) {
          panel.__ssQuote = null;
          customError(panel, result.body.error);
          pendingReadings(panel);
          tiers.forEach(function (input) {
            writeTierPrice(input, '');
          });
          setContinue(panel, null);
          return;
        }

        panel.__ssQuote = result.body;
        customError(panel, '');
        applyQuote(panel, result.body, tiers);
        setContinue(panel, hrefFor(panel, result.body));
      });
    }

    /* Typing settles before it is priced; a pill click is priced at once. */
    function scheduleQuote(panel) {
      panel.__ssQuoteId = (panel.__ssQuoteId || 0) + 1;
      var request = panel.__ssQuoteId;

      clearTimeout(panel.__ssQuoteTimer);
      panel.__ssQuoteTimer = setTimeout(function () {
        refreshQuote(panel, request);
      }, 250);
    }

    /*
     * Continue carries the configuration, never a price and never a variant.
     * The upload page confirms it with the service and asks for the variant
     * only when artwork is submitted, so a customer who leaves at the upload
     * step never mints anything. The service re-prices from these numbers
     * and ignores any price, so a hand-edited link buys a different sheet,
     * never a cheaper one.
     *
     * The same configuration is also kept in session storage. Shopify's
     * Sign in with Shop handshake can rewrite the first URL a visitor opens
     * and drop its query parameters, which was seen stripping the upload
     * link of everything but the product. The upload page falls back to
     * this copy when the URL arrives empty-handed.
     */
    var STASH_KEY = 'ss:configuration';

    function stashConfiguration(handle, quote) {
      try {
        window.sessionStorage.setItem(
          STASH_KEY,
          JSON.stringify({
            product: handle || '',
            widthIn: quote.widthIn,
            heightIn: quote.heightIn,
            quantity: quote.quantity,
            finish: quote.finish,
            at: Date.now()
          })
        );
      } catch (error) {
        /* Storage unavailable: the URL still carries everything. */
      }
    }

    function hrefFor(panel, quote) {
      var uploadUrl = panel.getAttribute('data-ss-upload-url');
      var handle = panel.getAttribute('data-ss-handle');
      if (!uploadUrl) return null;

      stashConfiguration(handle, quote);

      var query = [
        'width=' + encodeURIComponent(quote.widthIn),
        'height=' + encodeURIComponent(quote.heightIn),
        'quantity=' + encodeURIComponent(quote.quantity),
        'finish=' + encodeURIComponent(quote.finish)
      ];
      if (handle) query.unshift('product=' + encodeURIComponent(handle));
      /* Only the link carries the edit key, never the session copy: a stale
         key there could replace a cart line on some later, unrelated sheet. */
      if (EDIT) query.push('edit=' + encodeURIComponent(EDIT));

      return uploadUrl + (uploadUrl.indexOf('?') === -1 ? '?' : '&') + query.join('&');
    }

    function writeReadings(panel, totalText, breakdownText) {
      var scope = panel.closest('.sheet-order') || document;

      scope.querySelectorAll('[data-ss-total]').forEach(function (element) {
        element.textContent = totalText;
      });

      scope.querySelectorAll('[data-ss-breakdown]').forEach(function (element) {
        element.textContent = breakdownText;
      });
    }

    function pendingReadings(panel) {
      var settings = config(panel);
      writeReadings(panel, settings.pendingTotal, settings.pendingNote);
    }

    /*
     * The continue control navigates, so "enabled" means it has somewhere
     * true to point. An unpriced configuration removes the href entirely,
     * which makes the anchor inert without needing a disabled attribute
     * anchors do not support.
     */
    function setContinue(panel, href) {
      var scope = panel.closest('.sheet-order') || document;

      scope.querySelectorAll('[data-ss-continue]').forEach(function (control) {
        if (href) {
          control.setAttribute('href', href);
        } else {
          control.removeAttribute('href');
        }
      });
    }

    function recalculate(panel) {
      var chosen = {};

      STEPS.forEach(function (step) {
        chosen[step] = selectedInput(panel, step);

        /*
         * The descriptor rides on the selected input, so the step that owns the
         * copy also owns the lookup: the controller stays free of content.
         */
        var descriptor = panel.querySelector('[data-ss-descriptor-for="' + step + '"]');
        if (descriptor) {
          descriptor.textContent = chosen[step]
            ? chosen[step].getAttribute('data-ss-desc') || ''
            : '';
        }

        var echo = panel.querySelector('[data-ss-echo="' + step + '"]');
        if (!echo) return;

        var label = chosen[step] ? chosen[step].getAttribute('data-ss-label') : '';
        echo.textContent = label ? ' · ' + label : '';
      });

      /* Remembered while a stock pill still holds it, for Custom to open on. */
      var remembered = panel.__ssLastPreset || {};

      if (chosen.size && !chosen.size.hasAttribute('data-ss-custom')) {
        remembered.size = chosen.size.getAttribute('data-ss-value');
      }
      if (chosen.quantity && !chosen.quantity.hasAttribute('data-ss-custom')) {
        remembered.quantity = parseInt(chosen.quantity.getAttribute('data-ss-count'), 10);
      }

      panel.__ssLastPreset = remembered;

      var custom = isCustom(panel);
      panel.setAttribute('data-ss-custom', custom ? 'true' : 'false');

      /*
       * Each axis opens only its own field, so a custom size keeps the tier
       * pills and a custom quantity keeps the size pills. Opening one prefills
       * it from the value it is replacing, so Custom starts where the customer
       * already was rather than at a default they did not choose.
       */
      ['size', 'quantity'].forEach(function (step) {
        var open = customPicked(panel, step);
        var group = panel.querySelector('.ss-step--' + step + ' [data-ss-custom-fields]');
        if (!group) return;

        if (open && group.hidden) prefillCustom(panel, step);
        group.hidden = !open;
      });

      if (customPicked(panel, 'quantity')) syncQuantitySlider(panel);

      /* Hold the last good reading rather than flashing pending while the
         next one is fetched; only the first quote starts from the placeholder.
         The page's own opening reading (Shopify's price for the configuration
         the panel opens on) is held too, but on the first pass only, and not
         when a link opened the panel on some other configuration. */
      var opening = !panel.__ssOpeningUsed && !START && !!panel.querySelector('[data-ss-opening]');
      panel.__ssOpeningUsed = true;

      if (!panel.__ssQuote) {
        if (!opening) {
          pendingReadings(panel);
          tierInputs(panel).forEach(function (input) {
            writeTierPrice(input, '');
          });
        }
        setContinue(panel, null);
      }

      refreshQuote(panel);
    }

    function pick(input) {
      if (input) input.checked = true;
      return !!input;
    }

    /*
     * Runs once, before the first reading. Custom opens on these values, not
     * on a remembered preset: nothing is remembered yet on the first pass, so
     * prefillCustom leaves the fields as set here.
     */
    function applyStart(panel) {
      if (!START || panel.__ssStarted) return;
      panel.__ssStarted = true;

      Array.prototype.some.call(panel.querySelectorAll('input[data-ss-step="finish"]'), function (input) {
        return String(input.getAttribute('data-ss-value')).toLowerCase() === START.finish && pick(input);
      });

      var sizeMatched = Array.prototype.some.call(
        panel.querySelectorAll('input[data-ss-step="size"]:not([data-ss-custom])'),
        function (input) {
          var size = parseSize(input.getAttribute('data-ss-value'));
          return !!size && size.widthIn === START.widthIn && size.heightIn === START.heightIn && pick(input);
        }
      );
      if (!sizeMatched && pick(panel.querySelector('input[data-ss-step="size"][data-ss-custom]'))) {
        var width = customInput(panel, 'width');
        var height = customInput(panel, 'height');
        if (width) width.value = String(START.widthIn);
        if (height) height.value = String(START.heightIn);
      }

      var quantityMatched = Array.prototype.some.call(
        panel.querySelectorAll('input[data-ss-step="quantity"]:not([data-ss-custom])'),
        function (input) {
          return parseInt(input.getAttribute('data-ss-count'), 10) === START.quantity && pick(input);
        }
      );
      if (!quantityMatched && pick(panel.querySelector('input[data-ss-step="quantity"][data-ss-custom]'))) {
        var field = customInput(panel, 'quantity');
        if (field) field.value = String(START.quantity);
      }
    }

    function recalculateAll() {
      document.querySelectorAll('[data-ss-panel]').forEach(function (panel) {
        applyStart(panel);
        recalculate(panel);
      });
    }

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.matches) return;

      var panel = input.closest('[data-ss-panel]');
      if (!panel) return;

      if (input.matches('input[data-ss-step]')) {
        recalculate(panel);
        return;
      }

      if (input.matches('[data-ss-custom-input]')) scheduleQuote(panel);
    });

    /* Typing in a custom field must requote without waiting for a blur. */
    document.addEventListener('input', function (event) {
      var input = event.target;
      if (!input || !input.matches) return;

      var panel = input.closest('[data-ss-panel]');
      if (!panel) return;

      if (input.matches('[data-ss-custom-slider="quantity"]')) {
        var field = customInput(panel, 'quantity');
        if (field) {
          field.value = String(
            quantityFromPosition(Number(input.value), quantityBounds(panel))
          );
          input.setAttribute('aria-valuetext', field.value);
        }
        scheduleQuote(panel);
        return;
      }

      if (!input.matches('[data-ss-custom-input]')) return;

      if (input.getAttribute('data-ss-custom-input') === 'quantity') {
        syncQuantitySlider(panel);
      }

      scheduleQuote(panel);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', recalculateAll);
    } else {
      recalculateAll();
    }

    document.addEventListener('shopify:section:load', recalculateAll);
    document.addEventListener('shopify:block:select', recalculateAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["paste-try"] && !Shopify.designMode) return;
  try {
    class PasteTry extends HTMLElement {
    connectedCallback() {
      this.drop = this.querySelector('[data-empty]');
      this.card = this.querySelector('[data-result]');
      this.checker = this.querySelector('[data-checker]');
      this.image = this.querySelector('[data-image]');
      this.nameEl = this.querySelector('[data-name]');
      this.metaEl = this.querySelector('[data-meta]');
      this.afterEl = this.querySelector('[data-after]');
      this.errorEl = this.querySelector('[data-error]');
      this.field = this.querySelector('[data-paste]');

      /* A browser that cannot read the clipboard says so when the field is
         tapped; Cmd+V or Ctrl+V still works there. */
      this.field.addEventListener('click', () => {
        if (navigator.clipboard && typeof navigator.clipboard.read === 'function') {
          this.readClipboard();
        } else {
          this.setPasteState('error', this.dataset.tBlocked);
        }
      });
      this.querySelector('[data-remove]').addEventListener('click', () => this.reset());

      this.onPaste = (event) => this.fromPasteEvent(event);
      document.addEventListener('paste', this.onPaste);
    }

    disconnectedCallback() {
      document.removeEventListener('paste', this.onPaste);
      if (this.url) URL.revokeObjectURL(this.url);
    }

    /* Text pastes are left alone; only a pasted file is taken. */
    fromPasteEvent(event) {
      const data = event.clipboardData;
      if (!data) return;
      const file = Array.prototype.map
        .call(data.items || [], (item) => (item.kind === 'file' ? item.getAsFile() : null))
        .find(Boolean);
      if (!file) return;
      event.preventDefault();
      this.show(file);
    }

    /*
     * The upload page's paste field, step for step. Tapping away from
     * Safari's Paste bubble rejects the read, which is the customer changing
     * their mind, so the field just goes back. A refusal faster than anyone
     * could tap is the browser saying no without asking.
     */
    async readClipboard() {
      this.clearError();
      this.setPasteState('waiting');
      const asked = Date.now();
      let items;
      try {
        items = await navigator.clipboard.read();
      } catch (error) {
        const refused = error && error.name === 'NotAllowedError' && Date.now() - asked < 400;
        this.setPasteState(refused ? 'error' : '', refused ? this.dataset.tBlocked : '');
        return;
      }

      for (const item of items) {
        const type = item.types.find((name) => name.indexOf('image/') === 0);
        if (!type) continue;
        try {
          const blob = await item.getType(type);
          this.setPasteState('');
          this.show(new File([blob], this.pastedName(type), { type: type }));
        } catch (error) {
          this.setPasteState('error', this.dataset.tBlocked);
        }
        return;
      }
      this.setPasteState('error', this.dataset.tEmpty);
    }

    setPasteState(state, message) {
      this.field.dataset.state = state || '';
      this.querySelector('[data-paste-label]').textContent = message || this.dataset.tPaste;
    }

    /* Named the way the upload page names a pasted image. */
    pastedName(type) {
      const kinds = { 'image/png': '.png', 'image/jpeg': '.jpg', 'image/gif': '.gif', 'image/webp': '.webp' };
      const stamp = new Date().toISOString().slice(0, 19).replace('T', '-').replace(/:/g, '');
      return 'pasted-image-' + stamp + (kinds[type] || '.png');
    }

    show(file) {
      if (!file.type || file.type.indexOf('image/') !== 0) {
        this.showError(this.dataset.tNotImage);
        return;
      }
      this.clearError();
      const named = file.name && /\.[a-z0-9]+$/i.test(file.name) && file.name !== 'image.png';
      const ready = named ? file : new File([file], this.pastedName(file.type), { type: file.type });

      const url = URL.createObjectURL(ready);
      this.image.onload = () => {
        if (this.url) URL.revokeObjectURL(this.url);
        this.url = url;
        this.file = ready;
        const ratio = this.image.naturalWidth / this.image.naturalHeight || 1;
        this.checker.style.setProperty('--paste-ratio', String(ratio));
        this.nameEl.textContent = ready.name;
        this.metaEl.textContent = this.readableSize(ready.size) + ' · ' + (ready.name.split('.').pop() || '').toUpperCase();
        this.drop.hidden = true;
        this.card.hidden = false;
        this.afterEl.hidden = false;
      };
      this.image.onerror = () => {
        URL.revokeObjectURL(url);
        this.showError(this.dataset.tNotImage);
      };
      this.image.src = url;
    }

    readableSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1048576) return (bytes / 1024).toFixed(0) + ' KB';
      return (bytes / 1048576).toFixed(1) + ' MB';
    }

    reset() {
      if (this.url) URL.revokeObjectURL(this.url);
      this.url = null;
      this.file = null;
      this.image.removeAttribute('src');
      this.drop.hidden = false;
      this.card.hidden = true;
      this.afterEl.hidden = true;
      this.clearError();
      this.setPasteState('');
      this.field.focus();
    }

    showError(message) {
      this.errorEl.textContent = message || '';
      this.errorEl.hidden = !message;
    }

    clearError() {
      this.showError('');
    }
  }

  if (!customElements.get('paste-try')) {
    customElements.define('paste-try', PasteTry);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sheet-gallery"] && !Shopify.designMode) return;
  try {
    function showThumb(gallery, thumb) {
    var main = gallery.querySelector('.ss-gallery__main-image');
    var src = thumb.getAttribute('data-ss-main-src');

    gallery.querySelectorAll('[data-ss-thumb]').forEach(function (item) {
      item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false');
    });

    if (!main || !src) return;

    main.setAttribute('src', src);
    main.setAttribute('alt', thumb.getAttribute('data-ss-main-alt') || '');

    var credit = gallery.querySelector('[data-ss-credit]');
    if (credit) {
      var creditText = thumb.getAttribute('data-ss-main-credit') || '';
      credit.textContent = creditText;
      credit.hidden = !creditText;
    }

    var srcset = thumb.getAttribute('data-ss-main-srcset');
    if (srcset) {
      main.setAttribute('srcset', srcset);
    } else {
      main.removeAttribute('srcset');
    }
  }

  function revealThumb(gallery, thumb) {
    var strip = gallery.querySelector('.ss-gallery__thumbs');
    if (!strip) return;

    var stripBox = strip.getBoundingClientRect();
    var thumbBox = thumb.getBoundingClientRect();

    if (thumbBox.left < stripBox.left) {
      strip.scrollBy({ left: thumbBox.left - stripBox.left, behavior: 'smooth' });
    } else if (thumbBox.right > stripBox.right) {
      strip.scrollBy({ left: thumbBox.right - stripBox.right, behavior: 'smooth' });
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var step = target.closest('[data-gallery-step]');
    var thumb = step ? null : target.closest('[data-ss-thumb]');
    if (!step && !thumb) return;

    var gallery = (step || thumb).closest('[data-ss-gallery]');
    if (!gallery) return;

    if (step) {
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-ss-thumb]'));
      if (thumbs.length < 2) return;

      var current = thumbs.findIndex(function (item) {
        return item.getAttribute('aria-pressed') === 'true';
      });
      if (current < 0) current = 0;

      var offset = parseInt(step.getAttribute('data-gallery-step'), 10) || 1;
      thumb = thumbs[(current + offset + thumbs.length) % thumbs.length];
      revealThumb(gallery, thumb);
    }

    showThumb(gallery, thumb);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["step-finish"] && !Shopify.designMode) return;
  try {
    (function () {
    /*
     * Plays the shiny chips in turn on phones, tablets and touch screens.
     * "Below desktop" is the theme's 990px desktop breakpoint; "touch" is a
     * coarse pointer, which catches a tablet or touch laptop wider than that.
     * The sequence starts only when every shiny pill is fully in view, and
     * stops if any of them leaves, so it is never half-seen. Scrolling them
     * out and back in plays it again.
     */
    var DEVICE = window.matchMedia('(max-width: 989px), (pointer: coarse)');
    var CALM = window.matchMedia('(prefers-reduced-motion: reduce)');
    var ORDER = ['Gloss', 'Holographic', 'Silver Flake'];
    var STEP_MS = 900;
    var LAST_MS = 1100;
    var FULL = 0.98;
    var CLASS = 'is-glinting';

    function setup(step) {
      if (step.ssGlint || !('IntersectionObserver' in window)) return;

      var pills = [];
      ORDER.forEach(function (value) {
        step.querySelectorAll('.ss-option--swatch').forEach(function (pill) {
          var input = pill.querySelector('input');
          if (input && input.value === value) pills.push(pill);
        });
      });
      if (!pills.length) return;

      var inView = new Map();
      var timers = [];
      var played = false;

      function stop() {
        timers.forEach(clearTimeout);
        timers = [];
        pills.forEach(function (pill) {
          pill.classList.remove(CLASS);
        });
      }

      function play() {
        stop();
        pills.forEach(function (pill, index) {
          timers.push(setTimeout(function () {
            if (index > 0) pills[index - 1].classList.remove(CLASS);
            pill.classList.add(CLASS);
          }, index * STEP_MS));
        });
        timers.push(setTimeout(stop, (pills.length - 1) * STEP_MS + LAST_MS));
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView.set(entry.target, entry.isIntersecting && entry.intersectionRatio >= FULL);
        });

        var allInView = pills.every(function (pill) {
          return inView.get(pill);
        });

        if (!allInView) {
          played = false;
          stop();
        } else if (!played && DEVICE.matches && !CALM.matches) {
          played = true;
          play();
        }
      }, { threshold: [0, FULL, 1] });

      pills.forEach(function (pill) {
        observer.observe(pill);
      });

      step.ssGlint = { observer: observer, stop: stop };
    }

    function setupAll() {
      document.querySelectorAll('.ss-step--finish').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAll);
    } else {
      setupAll();
    }

    document.addEventListener('shopify:section:load', setupAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
